import {
  BaseActionWidget,
  ClickResult,
  DialogViewActionWidget,
  ModelFieldType,
  SPI,
  Widget
} from '@kunlun/dependencies';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';

const MODEL = 'deli.aries.seller.DeliAriesTodChangePptModel';

@SPI.ClassFactory(
  BaseActionWidget.Token({
    model: MODEL,
    name: ['internalGotoListExportDialog', '$$internal_GotoListExportDialog']
  })
)
export class TodChangePptExport extends DialogViewActionWidget {
  protected clickAction(...args: unknown[]): Promise<ClickResult> {
    const selected = (this.activeRecords ?? []) as Record<string, any>[];
    const table = this.findTable(this.rootHandle ? Widget.select(this.rootHandle) : null, 0);
    const tableData = (table && typeof table.getData === 'function' ? table.getData() : null) as
      | Record<string, any>[]
      | null;
    const all = (tableData && tableData.length ? tableData : (this.dataSource ?? [])) as Record<string, any>[];
    const rows = selected.length ? selected : all;
    const columns = table && typeof table.getColumnWidgets === 'function' ? table.getColumnWidgets(true) ?? [] : [];
    const enumMaps: Record<string, Record<string, string>> = {};

    const targetData = rows.map((row) => {
      const out: Record<string, unknown> = {};
      if (columns.length) {
        columns.forEach((col) => {
          const { label, name, ttype, options } = col.field ?? {};
          if (!name || String(name).toLowerCase() === 'id') return;
          if (ttype === ModelFieldType.Enum) {
            if (!enumMaps[name]) {
              enumMaps[name] = {};
              (options ?? []).forEach((o: any) => {
                enumMaps[name][o.name] = (o.displayName ?? '').trim();
              });
            }
            out[label] = enumMaps[name][row[name] as string];
          } else {
            out[label] = row[name];
          }
        });
      } else {
        Object.keys(row).forEach((k) => {
          if (k.toLowerCase() !== 'id') out[k] = row[k];
        });
      }
      return out;
    });

    this.saveJsonToExcel(targetData, '变更促销类型.xlsx');
    return false as any;
  }

  private findTable(w: any, depth: number): any {
    if (!w || depth > 30) return null;
    if (typeof w.getColumnWidgets === 'function' && typeof w.getData === 'function') return w;
    const children = (typeof w.getChildren === 'function' ? w.getChildren() : []) ?? [];
    for (const child of children) {
      const found = this.findTable(child, depth + 1);
      if (found) return found;
    }
    return null;
  }

  private saveJsonToExcel(data: Record<string, unknown>[], filename: string) {
    const sheet = XLSX.utils.json_to_sheet(data);
    const workbook = { SheetNames: ['sheet1'], Sheets: { sheet1: sheet } };
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', bookSST: true, type: 'array' });
    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename);
  }
}
